import { Injectable, InjectionToken } from "@angular/core";
import { Observable } from "rxjs";
import {
  CustomerGetQueryResult, IUserInformationGetQuery, IUserInformationGetQueryResult, UserCustomerListGetQueryResult, UserDeleteCommandResult,
  UserFavoritesInitializeCommandResult, UserGetQueryResult, UserInformationSetCommand,
  UserInformationSetCommandResult, UserListGetQueryResult, UserPasswordResetCommand, UserPasswordResetCommandResult,
  UserPasswordResetLinkSendCommand, UserPasswordResetLinkSendCommandResult, UserPasswordResetLinkVerifyCommand,
  UserPasswordResetLinkVerifyCommandResult, UserPasswordSetCommand, UserPasswordSetCommandResult,
  UserRegisterCommand, UserRegisterCommandResult, UserSetCommand, UserSetCommandResult
} from "../../INTEGRA_Shop_Client";

@Injectable({
  providedIn: 'root'
})
export abstract class IUserApiService {
  abstract userLogin(customerNumber: string, coUserNumberOrEmailOrAlias: string, password: string): Observable<string>;

  abstract userIDPLogin(userData: any, accessToken: string, idToken: string): Observable<string>;

  abstract userLogout(): Observable<void>;

  abstract loginAsMitben(key: string): Observable<string>;

  abstract userLoginByRefreshToken(): Observable<string>;

  abstract userInformationGet(
    params?: Partial<IUserInformationGetQuery>,
    allowCancellation?: boolean | undefined
  ): Observable<IUserInformationGetQueryResult>;

  abstract userInformationSet(command: UserInformationSetCommand): Observable<UserInformationSetCommandResult>;

  abstract userGet(userNumber?: string | undefined, loadOnlyActive?: boolean | undefined): Observable<UserGetQueryResult>;

  abstract userSet(command: UserSetCommand): Observable<UserSetCommandResult>;

  abstract userListGet(): Observable<UserListGetQueryResult>;

  abstract userDelete(userNumber?: string | undefined): Observable<UserDeleteCommandResult>;

  abstract userPasswordReset(command: UserPasswordResetCommand): Observable<UserPasswordResetCommandResult>;

  abstract userPasswordResetLinkSend(command: UserPasswordResetLinkSendCommand): Observable<UserPasswordResetLinkSendCommandResult>;

  abstract userPasswordResetLinkVerify(command: UserPasswordResetLinkVerifyCommand): Observable<UserPasswordResetLinkVerifyCommandResult>;

  abstract userPasswordSet(command: UserPasswordSetCommand): Observable<UserPasswordSetCommandResult>;

  abstract customerGet(customerNumber: string | undefined): Observable<CustomerGetQueryResult>;

  abstract userCustomerListGet(): Observable<UserCustomerListGetQueryResult>;

  abstract userSwitchCustomer(customerNumber?: string | undefined): Observable<string>;

  abstract userRegister(command: UserRegisterCommand): Observable<UserRegisterCommandResult>;

  abstract userFavoritesInitialize(): Observable<UserFavoritesInitializeCommandResult>;
}

/** Injection token which makes it possible to provide and inject the interface. */
// eslint-disable-next-line @typescript-eslint/naming-convention
export const IUserApiServiceToken = new InjectionToken<IUserApiService>('IUserApiServiceToken');
